angular.module('project')
    .directive('projectPicker', function (Project) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                userProjectsFilter: '=',
                required: "=",
                modelType: '=',
                onChange: "&",
                initialValue: "=?"
            },
            templateUrl: "app/project/picker/picker.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {

                scope.executeOnChange = scope.onChange || angular.noop
                scope.modelTypeR = scope.modelType || "object"
                scope.currentUserOnly = scope.userProjectsFilter || false
                scope.initialSelectionSynced = false

                let projects = {
                    "Mirabelkowa Aleja": "1212_MAleja W",
                    "Manu Park": "1003_Manu Park",
                    "Platon": "1007_Platon",
                    "Hygge House": "1004_Hygge",
                    "Domy Sycylijska": "1010_Sycylijska",
                }

                scope.refreshData = search => {
                    return Project.autocomplete({userProjectsFilter: scope.userProjectsFilter, search: search}).$promise.then(items => {
                        scope.items = sortProjects(items)
                        syncInitialSelection()
                    })
                }

                scope.refreshData()

                function syncInitialSelection() {
                    if (scope.initialSelectionSynced) {
                        return
                    }
                    scope.initialSelectionSynced = true
                    if (scope.initialValue != null && typeof scope.initialValue === "string") {
                        if (scope.selected == null) {
                            let shortInitialValue = scope.initialValue.slice(0, scope.initialValue.indexOf("-")).trim();
                            let projectByShortName = projects[shortInitialValue]
                            if (projectByShortName != null) {
                                scope.initialValue = projectByShortName
                            }
                        }
                        let selectedProject = scope.items.find(i => i.name === scope.initialValue)
                        scope.selected = modelToViewValue(selectedProject)
                        if (selectedProject) {
                            scope.onSelectionChanged(selectedProject, scope.selected)
                        }
                    } else {
                        scope.selected = modelToViewValue(ngModelCtrl.$modelValue)
                    }
                }

                ngModelCtrl.$render = () => scope.selected = modelToViewValue(ngModelCtrl.$viewValue)
                ngModelCtrl.$formatters.push(modelToViewValue)
                ngModelCtrl.$parsers.push(viewValue => {
                    if (viewValue == null || viewValue === '') {
                        return null
                    }
                    return scope.modelTypeR === "id" ? projectId(viewValue) : findProject(viewValue)
                })

                scope.onSelectionChanged = ($item, $model) => {
                    let viewValue = projectId($model)
                    if (isSameProject(ngModelCtrl.$modelValue, viewValue) || isSameProject(ngModelCtrl.$viewValue, viewValue)) {
                        scope.selected = viewValue
                        ngModelCtrl.$validate()
                        return
                    }
                    ngModelCtrl.$setViewValue(viewValue)
                    ngModelCtrl.$validate()
                    if (angular.isFunction(scope.executeOnChange())) {
                        scope.executeOnChange()($item)
                    }
                }

                function modelToViewValue(value) {
                    if (value == null || value === '') {
                        return null
                    }
                    return angular.isObject(value) ? value.id : value
                }

                function projectId(value) {
                    if (value == null || value === '') {
                        return null
                    }
                    return angular.isObject(value) ? value.id : value
                }

                function findProject(value) {
                    let id = projectId(value)
                    return (scope.items || []).find(item => item && String(item.id) === String(id)) || null
                }

                function isSameProject(currentValue, nextViewValue) {
                    let currentId = projectId(currentValue)
                    let nextId = projectId(nextViewValue)
                    return currentId == null ? nextId == null : String(currentId) === String(nextId)
                }

                function sortProjects(items) {
                    if (!angular.isArray(items)) {
                        return []
                    }
                    return items.slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                }
            }
        }
    })
